import { TPackages, TradingPlatForms } from '@src/types';
import { ReactNode } from 'react';

export const packages: TPackages[] = [
  {
    id: 1,
    display_name_app: '$25,000',
    billing_plan: { first_price: 99 },
    addons: [
      {
        id: 101,
        display_name_app: '3 minis | 30 micros',
        price: 0,
        title: '3 minis | 30 micros',
      },
      {
        id: 102,
        display_name_app: '$1,500 profit target',
        price: 0,
        title: '$1,500 profit target',
      },
      {
        id: 103,
        display_name_app: '$1,500 Trailing Drawdown',
        price: 0,
        title: '$1,500 Trailing Drawdown',
      },
    ],
  },
  {
    id: 2,
    display_name_app: '$50,000',
    billing_plan: { first_price: 149 },
    addons: [
      {
        id: 104,
        display_name_app: '8 minis | 80 micros',
        price: 0,
        title: '6 contracts',
      },
      {
        id: 105,
        display_name_app: '$3,000 profit target',
        price: 0,
        title: '$3,000 profit target',
      },
      {
        id: 106,
        display_name_app: '$2,500 Trailing Drawdown',
        price: 0,
        title: '$2,500 Trailing Drawdown',
      },
    ],
  },
  {
    id: 3,
    display_name_app: '$100,000',
    billing_plan: { first_price: 249 },
    addons: [
      {
        id: 107,
        display_name_app: '12 minis | 120 micros',
        price: 0,
        title: '12 minis | 120 micros',
      },
      {
        id: 108,
        display_name_app: '$6,000 profit target',
        price: 0,
        title: '$6,000 profit target',
      },
      {
        id: 109,
        display_name_app: '$3,000 Trailing Drawdown',
        price: 0,
        title: '$3,000 Trailing Drawdown',
      },
    ],
  },
  {
    id: 4,
    display_name_app: '$150,000',
    billing_plan: { first_price: 349 },
    addons: [
      {
        id: 111,
        display_name_app: '15 minis | 150 micros',
        price: 0,
        title: '15 minis | 150 micros',
      },
      {
        id: 112,
        display_name_app: '$9,000 profit target',
        price: 0,
        title: '$9,000 profit target',
      },
      {
        id: 113,
        display_name_app: '$5,000 Trailing Drawdown',
        price: 0,
        title: '$5,000 Trailing Drawdown',
      },
    ],
  },
  {
    id: 5,
    display_name_app: '$300,000',
    billing_plan: { first_price: 599 },
    addons: [
      {
        id: 114,
        display_name_app: '30 minis | 300 micros',
        price: 0,
        title: '30 minis | 300 micros',
      },
      {
        id: 115,
        display_name_app: '$20,000 profit target',
        price: 0,
        title: '$20,000 profit target',
      },
      {
        id: 116,
        display_name_app: '$7,500 Trailing Drawdown',
        price: 0,
        title: '$7,500 Trailing Drawdown',
      },
    ],
  },
];

export const iconsPackage: ReactNode[] = [
  <svg
    key="1"
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3327 9.81667L16.866 3.70833L18.3077 4.54167L13.9493 12.0833L8.52435 8.95833L4.54935 15.8333H18.3327V17.5H1.66602V2.5H3.33268V14.6167L7.91601 6.66667L13.3327 9.81667Z"
      fill="currentColor"
    />
  </svg>,
  <svg
    key={2}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 11L7.83 11L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
      fill="currentColor"
    />
  </svg>,
  <svg
    key={3}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.558 2.98196C12.1941 2.85882 11.7998 2.85882 11.436 2.98196L4.65995 5.27696C4.43925 5.34865 4.24432 5.48331 4.09916 5.66436C3.954 5.84541 3.86495 6.06495 3.84295 6.29596C3.50595 10.522 4.09095 13.647 5.47995 16.008C6.82395 18.293 8.97395 19.954 11.997 21.192C15.023 19.954 17.175 18.293 18.519 16.008C19.909 13.648 20.494 10.522 20.157 6.29596C20.135 6.06495 20.0459 5.84541 19.9007 5.66436C19.7556 5.48331 19.5607 5.34865 19.34 5.27696L12.558 2.98196ZM10.955 1.56196C11.6307 1.33288 12.363 1.33253 13.039 1.56096L19.821 3.85596C20.3191 4.02187 20.7578 4.32994 21.083 4.74219C21.4082 5.15445 21.6056 5.65285 21.651 6.17596C22.004 10.586 21.411 14.052 19.812 16.769C18.208 19.494 15.651 21.367 12.272 22.698C12.0952 22.7676 11.8987 22.7676 11.722 22.698C8.34595 21.367 5.78995 19.494 4.18695 16.769C2.58895 14.052 1.99595 10.585 2.34795 6.17596C2.39327 5.65285 2.5907 5.15445 2.91588 4.74219C3.24106 4.32994 3.67978 4.02187 4.17795 3.85596L10.955 1.56196Z"
      fill="currentColor"
    />
    <path
      d="M12 20C17.032 17.96 19.406 14.382 18.943 7.63297C18.891 6.86597 18.367 6.21697 17.64 5.96397L12.82 4.28597C12.5563 4.19418 12.2792 4.1472 12 4.14697V20Z"
      fill="currentColor"
      opacity="0.5"
    />
  </svg>,
  <svg
    key={4}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 21V19H19V11.9C19 9.95 18.321 8.296 16.963 6.938C15.605 5.58 13.9507 4.90067 12 4.9C10.0493 4.89933 8.39533 5.57867 7.038 6.938C5.68067 8.29733 5.00133 9.95133 5 11.9V18H2V12.275H3L3.075 10.95C3.20833 9.81667 3.53767 8.76667 4.063 7.8C4.58833 6.83333 5.24667 5.99167 6.038 5.275C6.82933 4.55833 7.73733 4 8.762 3.6C9.78667 3.2 10.866 3 12 3C13.134 3 14.209 3.2 15.225 3.6C16.241 4 17.1493 4.55433 17.95 5.263C18.7507 5.97167 19.409 6.809 19.925 7.775C20.441 8.741 20.7743 9.791 20.925 10.925L21 12.275H22V18H21V21H11ZM9 14C8.71667 14 8.47933 13.904 8.288 13.712C8.09667 13.52 8.00067 13.2827 8 13C7.99933 12.7173 8.09533 12.48 8.288 12.288C8.48067 12.096 8.718 12 9 12C9.282 12 9.51967 12.096 9.713 12.288C9.90633 12.48 10.002 12.7173 10 13C9.998 13.2827 9.902 13.5203 9.712 13.713C9.522 13.9057 9.28467 14.0013 9 14ZM15 14C14.7167 14 14.4793 13.904 14.288 13.712C14.0967 13.52 14.0007 13.2827 14 13C13.9993 12.7173 14.0953 12.48 14.288 12.288C14.4807 12.096 14.718 12 15 12C15.282 12 15.5197 12.096 15.713 12.288C15.9063 12.48 16.002 12.7173 16 13C15.998 13.2827 15.902 13.5203 15.712 13.713C15.522 13.9057 15.2847 14.0013 15 14ZM6.025 12.45C5.90833 10.6833 6.44167 9.16667 7.625 7.9C8.80833 6.63333 10.2833 6 12.05 6C13.5333 6 14.8377 6.47067 15.963 7.412C17.0883 8.35333 17.7673 9.558 18 11.026C16.4833 11.0087 15.0877 10.6 13.813 9.8C12.5383 9 11.559 7.91667 10.875 6.55C10.6083 7.88333 10.046 9.071 9.188 10.113C8.33 11.155 7.27567 11.934 6.025 12.45Z"
      fill="currentColor"
    />
  </svg>,
  <svg
    key={5}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 17V10.1L12 15L1 9L12 3L23 9V17H21ZM12 21L5 17.2V12.2L12 16L19 12.2V17.2L12 21Z"
      fill="currentColor"
    />
  </svg>,
];

export type AddOnItem = {
  id?: number;
  title?: string;
  sub?: string;
  price?: number;
  priceLater?: number;
  priceNote?: string;
  rangular?: number;
  rangular_percent?: number;
  disabled?: boolean;
  default?: boolean;
  first_period_unit?: string;
  addon_performance_account_fee_option?: string;
  discount_percent?: number | null;
};

export type AddOnGroup = {
  title: string;
  title2?: string;
  description?: string;
  optional?: boolean;
  data: AddOnItem[];
  data2?: AddOnItem[];
  note?: string;
  addon_type?: string;
};

export const addOnsData: AddOnGroup[] = [
  // Payout speed options
  {
    title: 'Payout Speed',
    optional: false,
    data: [
      {
        title: 'Express (3 Business Days)',
        sub: 'Receive payouts within 3 business days',
        price: 19.99,
      },
      {
        title: '10-Day Payout',
        sub: 'Standard payout timeline with enhanced features',
        price: 30.0,
      },
      {
        title: '15-Day Payout',
        sub: 'Extended payout timeline with lower fees',
        price: 20.0,
      },
      {
        title: 'Last Saturday monthly —(No price change)',
        sub: 'Extended payout timeline with lower fees  ',
        price: 20.0,
      },
    ],
    note: '<b>Note</b>: Payout requests may be submitted on the nearest Saturday between <b>2:00 AM and 5:00 PM EST.</b> ',
  },

  // Practice resets and safety nets
  {
    optional: true,
    title: 'Practice Resets',
    data: [
      { title: 'Practice Reset', sub: '60% if buying it now', price: 19.99 },
    ],
    note: '<b>Note</b>: A reset does not change the subscription renewal date (monthly plan) or the <b>30-day expiry</b> (non-recurring plan).',
  },

  // Cost adjustments and fees
  {
    optional: false,
    title: 'Performance Account Fee',
    data: [
      { title: 'Monthly', sub: '$88/ month (pay if you qualify)', price: 0 },
      {
        title: 'Lifetime One-time payment',
        sub: '$250 (only if you qualify)',
        price: 0,
      },
      {
        title: 'Lifetime One-time payment',
        sub: 'Pay today and pay only $80 instead of $250 \n+$80 (regardless if you qualify or not) and if you qualify \nno activation fee',
        price: 80,
      },
      {
        title: 'Lifetime One-time payment',
        sub: 'IF you qualify, only pay $119',
        price: 20,
      },
    ],
  },

  // Payment & activation handling
  {
    optional: false,
    title: 'Payment & Activation Handling',
    data: [
      {
        title: 'Monthly subscription',
        sub: 'Renews every 30 calendar days ',
        price: 0,
      },
      {
        title: 'Non-recurring (no subscription)',
        sub: 'Single charge; expires after 30 calendar days',
        price: 0,
      },
    ],
  },
  {
    optional: false,
    title: 'Want to make it into a bundle?',
    note: '<b>Rule</b>: Only one account in the bundle can be converted to a Performance Account.',
    data: [
      {
        title: 'No, thanks! Keep only 1 account',
        sub: 'Renews every 30 calendar days ',
        price: 29.99,
        priceNote: 'Auto-reset at renewal',
      },
      {
        title: '3 accounts in a bundle',
        sub: 'Single charge; expires after 30 calendar days',
        price: 19.99,
        priceNote: 'Auto-reset at renewal',
      },
      {
        title: '5 accounts in a bundle',
        sub: 'Single charge; expires after 30 calendar days',
        price: 50.0,
        priceNote: 'No auto-reset',
      },
      {
        title: '7 accounts in a bundle',
        sub: 'Single charge; expires after 30 calendar days',
        price: 100.0,
        priceNote: 'No auto-reset',
      },
      {
        title: '10 accounts in a bundle',
        sub: 'Single charge; expires after 30 calendar days',
        price: 149.99,
        priceNote: 'No auto-reset',
      },
    ],
  },

  {
    optional: false,
    title: 'Drawdown',
    title2:
      'Add to your current drawdown additional drawdown (optional; cumulative; max +$1,500)',
    data: [
      {
        title: 'Trailing Drawdown',
        sub: 'Renews every 30 calendar days ',
        price: 30.0,
      },
      {
        title: 'End-of-Day Drawdown',
        sub: 'Single charge; expires after 30 calendar days',
        price: 20.0,
      },
      {
        title: 'Static Drawdown',
        sub: 'Single charge; expires after 30 calendar days',
        price: 50.0,
      },
    ],
    data2: [{ price: 500 }, { price: 1000 }, { price: 1500 }, { price: 0 }],
    note: '<b>Validation</b>: Extension total cannot exceed + $1,500.',
  },
  {
    optional: false,
    title: 'Min days to qualify after reaching profit target ',
    data: [
      { title: '1 Day', price: 59.0 },
      { title: '5 Days', price: 35.99 },
      { title: 'Standard 10 Days (No price change)', price: 89.99 },
    ],
  },
];

export const iconsImgPackage = {
  // [TradingPlatForms.CQG_DATA_FEED]: {
  //   icon: (
  //     <img alt="" src="./assets/icon-ninjatrader.png" style={{ height: 24 }} />
  //   ),
  //   text: 'NinjaTrader',
  // },
  // [TradingPlatForms.CQG_DATA_FEED_2]: {
  //   icon: (
  //     <img alt="" src="./assets/icon-ninjatrader.png" style={{ height: 24 }} />
  //   ),
  //   text: 'NinjaTrader',
  // },
  // [TradingPlatForms.DX_DATA_FEED]: {
  //   icon: (
  //     <img
  //       alt=""
  //       src="./assets/logo-dxfeed.png"
  //       style={{
  //         height: 20,
  //         width: 30,
  //         objectFit: 'cover',
  //         objectPosition: 'left',
  //       }}
  //     />
  //   ),
  //   text: 'DXFeed',
  // },
  [TradingPlatForms.RITHMIC_DATA_FEED]: {
    icon: <img alt="" src="./assets/icon-rithmic.png" style={{ height: 20 }} />,
    text: 'Rithmic',
  },
};

export const accountTypeData = [
  {
    index: 1,
    title: 'Practice Account',
    price: 15,
  },
  {
    index: 2,
    title: 'Straight to Performance Account',
    price: 20,
  },
  {
    index: 3,
    title: 'Specialty Accounts',
    price: 25,
  },
];

export const affiliateAccountTypeData = {
  practice_account: {
    title: 'Practice Account',
    price: 15,
  },
  straight_to_pa: {
    title: 'Straight to Performance Account',
    price: 20,
  },
  specialty_account: {
    title: 'Specialty Accounts',
    price: 25,
  },
};
